export default __webpack_public_path__ + "171e609bcae7a8b5e2930d1daa8d36f4.png";